import PropTypes from "prop-types";
import React, { Fragment } from "react";
import ShopTopAction from "../../components/product/ShopTopAction";
import { Divider } from "@mui/material";

const ShopTopbar = ({
  getLayout,
  getFilterSortParams,
  productCount,
  sortedProductCount,
  offset,
  userData,
  value,
  getSortParams,
  setSortValues,
  sortValues,
}) => {
  return (
    <Fragment>
      {/* shop top action */}
      <ShopTopAction
        getLayout={getLayout}
        getFilterSortParams={getFilterSortParams}
        productCount={productCount}
        sortedProductCount={sortedProductCount}
        offset={offset}
        userData={userData}
        query={value}
        getSortParams={getSortParams}
        setSortValues={setSortValues}
        sortValues={sortValues}
      />
      <Divider fullWidth style={{ color: "black" }} />
    </Fragment>
  );
};

ShopTopbar.propTypes = {
  getFilterSortParams: PropTypes.func,
  getLayout: PropTypes.func,
  productCount: PropTypes.number,
  sortedProductCount: PropTypes.number,
};

export default ShopTopbar;
